<template>
    <div>
        <div class="card my-1">
            <div
                class="collapse show"
                aria-labelledby="headingTwo"
                data-parent="#accordionResult"
            >
                <!-- title -->
                <div class="card-body">
                    <div class="bs-component"></div>
                    <div class="col-lg-8 float-left">
                        <h5>
                            <span class="text-primary">主数据</span>
                        </h5>
                    </div>
                    <div v-if="allowEdit && enableEdit()" class="float-lg-right">
                        <em-button type="edit" show-name
                                   :class="getEditButtonClass()"
                                   @click="isEdit=true">
                        </em-button>
                        <em-button type="view" show-name
                                   :class="getViewButtonClass()"
                                   @click="isEdit=false">
                        </em-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body" v-if="isEdit">

                <!--        这里先直接用modifyApi作为entityApi了，先不适配emBase/save中的api了   2020-12-18 by yuJiaBei-->
                <em-entity-edit-form :entity="modifyEntity" :$_em-custom-vuex-mixin_entity="modifyVuexState"
                                     auto-return-disable
                                     :entity-api="businessData.statusModifyApi"></em-entity-edit-form>
                <!--        <div class="float-lg-right">-->
                <!--          <em-button type="cancel" show-name v-bind:class="'btn btn-outline-secondary mr-1'"-->
                <!--                     v-on:click="handleCancel"></em-button>-->
                <!--          <em-button type="save" show-name v-bind:class="'btn btn-primary'"-->
                <!--                     v-on:click="handleSave"></em-button>-->
                <!--        </div>-->
            </div>
            <div class="card-body" v-else>
                <em-entity-viewer :entity="entity"
                                  :object="businessDataFromApi == null ? businessData : businessDataFromApi"
                                  :$_em-custom-vuex-mixin_configs="$_emCustomVuexMixin_configs"></em-entity-viewer>
            </div>
        </div>
    </div>
</template>

<script>
// Author YuJiaBei
// Date 2020-03-26 9:40:00

import EmButton from "@/components/em/EmButton";
import EmEntityEditForm from "@/components/em/EmEntity/EditForm";
import workflowUtil from "@/utils/workflowUtil";
import EmEntityViewer from "@/components/em/EmEntity/Viewer";
import emUtils from "@/utils/emUtils";
import _ from "lodash";

export default {
    name: "EmWorkflowBusinessDataEditor",
    components: {EmButton, EmEntityEditForm, EmEntityViewer},
    props: {
        entity: {
            type: String,
            required: true
        },
        businessData: {
            type: Object,
            required: true
        },
        allowEdit: {
            type: Boolean,
            default: true
        },
        $_emCustomVuexMixin_configs: String,
        queryApi: String
    },
    data: function () {
        return {
            isEdit: false,
            businessDataFromApi: null
        }
    },
    computed: {
        // businessData() {
        //   return this.$store.state[this.entity].processBusinessData
        // },
        modifyEntity() {
            return this.businessData.statusModifyEntity ? this.businessData.statusModifyEntity : this.entity
        },
        modifyVuexState() {
            return this.businessData.statusModifySaveForm ? `${this.businessData.statusModifySaveForm}Entity` : 'entity'
        }
    },
    methods: {
        enableEdit() {
            return workflowUtil.taskIsEdit(this, this.businessData)
        },
        //   //不分module了，和entity用一个module，只是有不同的saveForm和不同的saveApi前端配置  2020-12-16 by yujiabei
        // getVuexModuleName() {
        // let businessData = this.$store.state[this.entity].processBusinessData
        // //判断有没有自定义modifyForm，有就用，没有就默认用entity
        // if (businessData.statusAllowModify && businessData.statusModifyEntity) {
        //   //就把modifyFormName（首字母大写）拼装上entity组成新的store.modelName
        //   // vuexModuleName = this.entity + businessData.processStatusModifyFormName.charAt(0).toUpperCase() + businessData.processStatusModifyFormName.slice(1);
        //   //改为不拼接了，该字段直接就是entityName
        //   return businessData.statusModifyEntity
        // }
        //   return this.entity
        // },
        getSaveUrl() {
            let url = `${this.$store.state[this.entity].baseModuleUrl}/${this.entity}`
            //拼装api
            if (this.businessData && this.businessData.statusAllowModify && this.businessData.statusModifyApi) {
                //有自定义api就拼到entity后面
                url = `${url}/${this.businessData.statusModifyApi}`;
            } else {
                //没有自定义api就拼一个selective,默认部分修改
                url = `${url}/selective`;
            }
            // //拼装statusModifyEntity
            // if (businessData && businessData.statusAllowModify && businessData.statusModifyEntity) {
            //   //有就再拼装两级url，这是与后端的约定
            //   url = `${url}/workflow/modify-by/${emUtils.toUncapFirst(businessData.statusModifyEntity)}`;
            // }
            return url
        },
        //已经不用了，集成到em-entity-edit-form的cancel中了  2020-12-18
        handleCancel() {
            //深拷贝
            let _businessData = JSON.parse(JSON.stringify(this.businessData))
            let _statusModifyEntity = "Entity"
            //有自定义statusModifyEntity，就转首字母大写
            if (_businessData && _businessData.statusAllowModify && _businessData.statusModifyEntity) {
                _statusModifyEntity = emUtils.toCapFirst(_businessData.statusModifyEntity)
            }
            this.$store.commit(`${this.entity}/set${_statusModifyEntity}`, _businessData)
        },
        getEditButtonClass() {
            return this.isEdit ? 'btn btn-primary' : 'btn btn-outline-secondary mr-1'
        },
        getViewButtonClass() {
            return !this.isEdit ? 'btn btn-primary' : 'btn btn-outline-secondary mr-1'
        },
        //已经不用了，集成到em-entity-edit-form的save中了  2020-12-18
        handleSave() {
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    let statusModifyEntityName = "entity"
                    //有自定义statusModifyEntity，就转小写赋值
                    if (this.businessData && this.businessData.statusAllowModify && this.businessData.statusModifyEntity) {
                        statusModifyEntityName = emUtils.toUncapFirst(this.businessData.statusModifyEntity)
                    }
                    let entityAux = this.$store.state[this.entity][statusModifyEntityName]
                    //removing empty field
                    for (let key in entityAux) {
                        if (entityAux.hasOwnProperty(key) && entityAux[key] === "") delete entityAux[key]
                    }
                    this.$store.dispatch("api/put", {
                        url: this.getSaveUrl(),
                        entity: entityAux,
                        module: this.entity
                    }).then(entityReturn => {
                        //提示保存结果
                        this.$store.dispatch("base/showSuccess", {
                            userAlertSuccessStr: `保存成功 {id=${entityReturn.id}}`,
                            dismissCountDown: 5,
                            userAlertSuccessVisible: false,
                        })
                        //     .then(function () {
                        //         //暂时先不重新查询了。
                        // });
                    })
                }
            })
        },
        getBusinessDataByQueryApi() {
            if (this.queryApi !== undefined) {
                let url = `${this.$store.state[this.entity].baseModuleUrl}/${this.entity}/` + this.queryApi;
                this.$store.dispatch('api/post', {
                    url: url,
                    data: {
                        idFilter: this.businessData.id === undefined ? this.$route.query.id : this.businessData.id
                    }
                }).then(response => {
                    if (response.data.list.length === 1) {
                        this.businessDataFromApi = response.data.list[0];
                    }
                })
            }
        }
    },
    mounted() {
        //如果可修改，就为vuex中的相应entity赋值
        if (this.enableEdit()) {
            const saveEntity = _.cloneDeep(this.businessData);
            this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.modifyVuexState)}`, saveEntity);
            //setEntityOrigin已经是深克隆了
            this.$store.commit(`${this.entity}/setEntityOrigin`, saveEntity);
        }
        if (this.businessDataFromApi !== undefined) {
            this.getBusinessDataByQueryApi();
        }
    }
};
</script>